<template>
  <v-dialog
    v-model="show"
    max-width="500"
    persistent
  >
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text class="pb-0">
        <v-checkbox
          v-if="condition.length > 0"
          v-model="checked"
          dense
          hide-details
          class="mb-4"
          :label="condition"
        />

        <slot/>
      </v-card-text>

      <v-card-actions class="px-4 pb-4">
        <v-spacer/>

        <v-btn
          depressed
          @click="$emit('cancel')"
        >
          Peruuta
        </v-btn>

        <v-btn
          depressed
          :disabled="(!checked && condition.length > 0) || !valid"
          color="primary"
          @click="$emit('submit')"
        >
          {{ submitText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    valid: {
      type: Boolean,
      default: () => true,
    },
    title: {
      type: String,
      default: () => '',
    },
    condition: {
      type: String,
      default: () => '',
    },
    submitText: {
      type: String,
      default: () => 'Ok',
    },
  },
  data: () => ({
    checked: false,
  }),
  methods: {
    submit() {
      this.$emit('submit');
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>
